<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import type {
        OrganisationListEntry,
        OrganisationResponse,
        UserListEntry,
        UserResponse,
    } from "../../../../../../admin-service-typescript-client";
    import { ApiClient } from "../../../../../GlobalHelper/ApiClient";
    import { organisationStore } from "../../../../../store";
    import { user } from "../../../../../store/stores";
    import PermissionsTable from "./PermissionsTable.svelte";

    const navigate = useNavigate();
    export let organisationEntry: OrganisationListEntry;

    $: if (organisationEntry) {
        openDropdown = false;
    }

    let openDropdown: boolean = false;

    let userDetails: OrganisationResponse;

    const activateOrga = async () => {
        organisationStore.update((orgaStore) => {
            return {
                ...orgaStore,
                activeOrgaId: organisationEntry.id,
            };
        });
    };
</script>

<div class="column is-12">
    <div class="columns is-vcentered">
        <!-- <div class="column is-2">
            <figure
                class="image is-48x48"
                on:click={() => navigate(organisationEntry.id)}
            >
                <img
                    src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                    alt="Placeholder"
                />
            </figure>
        </div> -->
        <div
            class="column is-4 is-offset-1 username"
            on:click={() => navigate(organisationEntry.id)}
        >
            {organisationEntry.name}
        </div>
        <div
            class="column is-4 "
            on:click={() => navigate(organisationEntry.id)}
        >
            {organisationEntry.active ? "aktiviert" : "deaktiviert"}
        </div>
        <div
            class={`column is-2 ${
                $organisationStore.activeOrgaId === organisationEntry.id
                    ? ""
                    : "c-pointer"
            }`}
            on:click={() => activateOrga()}
        >
            <button
                disabled={$organisationStore.activeOrgaId ===
                    organisationEntry.id}
            >
                {$organisationStore.activeOrgaId === organisationEntry.id
                    ? "aktiv"
                    : "Wechseln"}
            </button>
        </div>
    </div>
</div>

<style>
    .card {
        margin: 5px 0;
    }

    .image,
    .icon {
        cursor: pointer;
    }
    .column {
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .box {
        height: 100%;
    }

    .username {
        color: darkblue;
        text-align: center;
    }

    /* unvisited link */
    .username:link {
        color: darkblue;
    }

    /* visited link */
    .username:visited {
        color: darkblue;
    }

    /* mouse over link */
    .username:hover {
        color: darkblue;
        cursor: pointer;
    }

    /* selected link */
    .username:active {
        color: darkblue;
    }

    .c-pointer {
        cursor: pointer;
    }
</style>
